export default "__VITE_ASSET__DX8$MZ2A__"